import { inject, Injectable } from '@angular/core';
import { KeyCloakConfig, KeyCloakInfo } from '@muvstok/ngx-muvstok';
import { ConfigService } from './config.service';

@Injectable({ providedIn: 'root' })
export class InitLoadService implements KeyCloakConfig {
  private configService = inject(ConfigService);

  loadActions(): Promise<boolean> {
    return this.configService.loadActions();
  }
  load(): Promise<KeyCloakInfo> {
    return this.configService.load();
  }
}
